import React, { useState } from 'react';
import {
  renderInputField,
  renderInputFieldWithTextBox,
  renderInputFieldWithoutLabel,
} from '../../../common/inputField';
import { setPatientData } from '../../../actions';
import { useDispatch, useSelector } from 'react-redux';
import { CustomTextArea } from '../../../common/CustomTextArea';
import DateComponent from '../../Registrationform/components/dateComponent';
import dayjs from 'dayjs';
import FileUploadCard from '../../../components/FileManager/FileUploadCard';
import FileDocumentCard from '../../../components/FileManager/FileDocumentCard';
import { toast } from 'sonner';
import {
  updateFileStatusUploaded,
  uploadPatientFileApi,
} from '../../../api/patientApi';
import { deleteFileApi } from '../../../api/fileApi';
import { useParams } from 'react-router-dom';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { Tab } from 'react-bootstrap';
const InvestigationOfFemalePartner = () => {
  const dispatch = useDispatch();
  const patientData = useSelector((state) => state.clinicalReducer);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    dispatch(setPatientData(`investigationOfFemalePartner.${name}`, value));
  };

  const [selectedDates, setSelectedDates] = useState(() => {
    if (!patientData?.investigationOfFemalePartner) {
      return {
        partnerInvestigationDate: null,
        partnerInvestigationHBDate: null,
        partnerUSGDate: null,
      };
    }

    const obj = {};
    const {
      partnerInvestigationDate,
      partnerInvestigationHBDate,
      partnerUSGDate,
    } = patientData.investigationOfFemalePartner;

    obj.partnerInvestigationDate = partnerInvestigationDate
      ? dayjs(partnerInvestigationDate)
      : null;

    obj.partnerInvestigationHBDate = partnerInvestigationHBDate
      ? dayjs(partnerInvestigationHBDate)
      : null;

    obj.partnerUSGDate = partnerUSGDate ? dayjs(partnerUSGDate) : null;

    console.log(obj);

    return obj;
  });

  const handleDateChange = (date, dateString, key) => {
    setSelectedDates({
      ...selectedDates,
      [key]: date,
    });
    handleInputChange({
      target: {
        name: key,
        value: dateString,
      },
    });
  };

  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [loadingText, setLoadingText] = useState('');
  const { id: patientId } = useParams();

  const handleUpload = async (file, patientId) => {
    if (!patientId) return toast.error('Patient not created');
    return new Promise((resolve, reject) => {
      try {
        toast.promise(
          uploadPatientFileApi(
            file,
            patientId,
            'Patient',
            updateFileStatusUploaded,
            'InvestigationOfFemalePartner',
          ),
          {
            loading: 'Uploading file...',
            success: (data) => {
              console.log(`data`, data);
              console.log(`uploadedFiles`, uploadedFiles);
              setUploadedFiles([...uploadedFiles, data]);
              setLoading(false);
              return resolve(data);
            },
            error: (err) => {
              reject('Failed to upload docs');
            },
            duration: 100,
          },
        );
      } catch (err) {
        setLoading(false);
        setLoadingText('');
        toast.error('Failed to upload file');
      }
    });
  };
  const handleDeleteFile = async (file) => {
    try {
      console.log('File to delete:', file);
      await deleteFileApi('patient', patientId, file.id);
      setUploadedFiles(
        uploadedFiles.filter((data) => data.fileId !== file.fileId),
      );
      toast.success('File deleted successfully');
    } catch (err) {
      toast.error('Error deleting file');
    }
  };

  const numberOfColumns = 2;

  const tableOneRowTitles = [
    { title: 'Date', field: 'partnerInvestigationDate', type: 'date' },
    { title: 'AMH', field: 'partnerAMH', type: 'text-field' },
    { title: 'FSH', field: 'partnerFSH', type: 'text-field' },
    { title: 'LH', field: 'partnerLH', type: 'text-field' },
    { title: 'E2', field: 'partnerE2', type: 'text-field' },
    { title: 'TSH', field: 'partnerTSH', type: 'text-field' },
    { title: 'PRL', field: 'partnerPRL', type: 'text-field' },
  ];

  const tableTwoRowTitles = [
    { title: 'Date', field: 'partnerInvestigationHBDate', type: 'date' },
    { title: 'HB', field: 'partnerHB', type: 'text-field' },
    { title: 'RBS', field: 'partnerRBS', type: 'text-field' },
    { title: 'Karyotyping', field: 'partnerKaryotyping', type: 'text-field' },
    { title: 'HIV', field: 'partnerHIV', type: 'text-field' },
    { title: 'HBsAg', field: 'partnerHBsAg', type: 'text-field' },
    { title: 'HCV', field: 'partnerHCV', type: 'text-field' },
    { title: 'VDRL', field: 'partnerVDRL', type: 'text-field' },
    { title: 'TB BACTEC C/S', field: 'partnerTBBactec', type: 'text-field' },
    { title: 'TB PCR', field: 'partnerTBPCR', type: 'text-field' },
    { title: 'Blood group', field: 'partnerBloodGroup', type: 'text-field' },
  ];

  const tableThreeRowTitles = [
    { title: 'HSG Date', field: 'partnerHSBDate', type: 'date' },
    {
      title: 'Findings',
      field: 'partnerExaminationFindings',
      type: 'text-area',
    },
  ];

  const tableFourRowTitles = [];

  const tableFiveRowTitles = [
    { title: 'USG', field: 'partnerUSG', type: 'text-area' },
    { title: 'USG Date', field: 'partnerUSGDate', type: 'date' },
    { title: 'Uterus', field: 'partnerUterus', type: 'text-area' },
    { title: 'ET', field: 'partnerET', type: 'text-area' },
    { title: 'Right Ovary', field: 'partnerRightOvary', type: 'text-area' },
    { title: 'Left Ovary', field: 'partnerLeftOvary', type: 'text-area' },
  ];

  const renderDateCell = (id, dateValue, handleChange, style = {}) => (
    <TableCell>
      <div className="female-examniation-container-one">
        <DateComponent
          id={id}
          selectedDate={dateValue}
          handleDateChange={(date, dateString) =>
            handleChange(date, dateString, id)
          }
          style={{ ...style }}
        />
      </div>
    </TableCell>
  );

  const renderInputCell = (name, value) => (
    <TableCell>
      {renderInputFieldWithoutLabel(name, value, handleInputChange)}
    </TableCell>
  );

  const renderRow = ({ title, field, type }) => {
    return (
      <TableRow key={field}>
        <TableCell>{title}</TableCell>
        {type === 'date' ? (
          renderDateCell(field, selectedDates[field], handleDateChange, {
            top: '0px',
          })
        ) : type === 'text-area' ? (
          <CustomTextArea
            value={patientData.investigationOfFemalePartner[field]}
            onChange={handleInputChange}
            name={field}
            maxRows={10}
            className="col-lg-12 col-md-6 padding-0"
          />
        ) : (
          renderInputCell(
            field,
            patientData.investigationOfFemalePartner[field],
          )
        )}
      </TableRow>
    );
  };

  const renderCell = (array) => {
    return array.map(({ title, field, type }) => (
      <React.Fragment>
        {/* <div style={{ display: 'flex' }}> */}
        {type === 'date' ? (
          renderDateCell(field, selectedDates[field], handleDateChange, {
            top: '0px',
          })
        ) : renderInputCell(
            field,
            patientData.investigationOfFemalePartner[field],
          ) ? (
          type === 'text-area' && (
            <TableCell>
              <CustomTextArea
                value={patientData.investigationOfFemalePartner[field]}
                onChange={handleInputChange}
                name={field}
                maxRows={10}
                className="col-lg-12 col-md-4 padding-0"
              />
            </TableCell>
          )
        ) : (
          <></>
        )}
        {/* </div> */}
      </React.Fragment>
    ));
  };
  return (
    <div className="theme-blush">
      <div className="container-fluid">
        <div className="card">
          <div className="header">
            <p className="lead">INVESTIGATIONS OF FEMALE PARTNER</p>
          </div>
          <div className="body">
            {/* <div className=" female-examination-container">
              <div className=" female-examniation-container-one">
                <div style={{ flex: '1 1' }}>
                  <label htmlFor="partnerInvestigationDate">Date</label>
                  <DateComponent
                    id="partnerInvestigationDate"
                    selectedDate={selectedDates['partnerInvestigationDate']}
                    handleDateChange={(date, dateString) =>
                      handleDateChange(
                        date,
                        dateString,
                        'partnerInvestigationDate',
                      )
                    }
                  />
                </div>
                {renderInputField(
                  'AMH',
                  'partnerAMH',
                  patientData.investigationOfFemalePartner.partnerAMH,
                  handleInputChange,
                )}

                {renderInputField(
                  'FSH',
                  'partnerFSH',
                  patientData.investigationOfFemalePartner.partnerFSH,
                  handleInputChange,
                )}
                {renderInputField(
                  'LH',
                  'partnerLH',
                  patientData.investigationOfFemalePartner.partnerLH,
                  handleInputChange,
                )}
                {renderInputField(
                  'E2',
                  'partnerE2',
                  patientData.investigationOfFemalePartner.partnerE2,
                  handleInputChange,
                )}
                {renderInputField(
                  'TSH',
                  'partnerTSH',
                  patientData.investigationOfFemalePartner.partnerTSH,
                  handleInputChange,
                )}
                {renderInputField(
                  'PRL',
                  'partnerPRL',
                  patientData.investigationOfFemalePartner.partnerPRL,
                  handleInputChange,
                )}
              </div>

              <div className=" female-examniation-container-second">
                <div style={{ flex: '1 1' }}>
                  <label htmlFor="partnerInvestigationHBDate">Date</label>
                  <DateComponent
                    id="partnerInvestigationHBDate"
                    selectedDate={selectedDates['partnerInvestigationHBDate']}
                    handleDateChange={(date, dateString) =>
                      handleDateChange(
                        date,
                        dateString,
                        'partnerInvestigationHBDate',
                      )
                    }
                  />
                </div>
                {renderInputField(
                  'HB',
                  'partnerHB',
                  patientData.investigationOfFemalePartner.partnerHB,
                  handleInputChange,
                )}
                {renderInputField(
                  'RBS',
                  'partnerRBS',
                  patientData.investigationOfFemalePartner.partnerRBS,
                  handleInputChange,
                )}

                {renderInputField(
                  'Karyotyping',
                  'partnerKaryotyping',
                  patientData.investigationOfFemalePartner.partnerKaryotyping,
                  handleInputChange,
                )}
                {renderInputField(
                  'HIV',
                  'partnerHIV',
                  patientData.investigationOfFemalePartner.partnerHIV,
                  handleInputChange,
                )}
                {renderInputField(
                  'HBsAg',
                  'partnerHBsAg',
                  patientData.investigationOfFemalePartner.partnerHBsAg,
                  handleInputChange,
                )}
                {renderInputField(
                  'HCV',
                  'partnerHCV',
                  patientData.investigationOfFemalePartner.partnerHCV,
                  handleInputChange,
                )}
                {renderInputField(
                  'VDRL',
                  'partnerVDRL',
                  patientData.investigationOfFemalePartner.partnerVDRL,
                  handleInputChange,
                )}
                {renderInputField(
                  'TB BACTEC C/S',
                  'partnerTBBactec',
                  patientData.investigationOfFemalePartner.partnerTBBactec,
                  handleInputChange,
                )}
                {renderInputField(
                  'TB PCR',
                  'partnerTBPCR',
                  patientData.investigationOfFemalePartner.partnerTBPCR,
                  handleInputChange,
                )}
                {renderInputField(
                  'Blood group',
                  'partnerBloodGroup',
                  patientData.investigationOfFemalePartner.partnerBloodGroup,
                  handleInputChange,
                )}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label htmlFor="partnerHSBDate">HSB Date</label>
                <DateComponent
                  id="partnerHSBDate"
                  selectedDate={selectedDates['partnerHSBDate']}
                  handleDateChange={(date, dateString) =>
                    handleDateChange(date, dateString, 'partnerHSBDate')
                  }
                />
              
                <div style={{ maxWidth: '600px' }} className="form-group">
                  <label htmlFor={'partnerExaminationFindings'}>Findings</label>
                  <CustomTextArea
                    value={
                      patientData.investigationOfFemalePartner
                        .partnerExaminationFindings
                    }
                    onChange={handleInputChange}
                    name="partnerExaminationFindings"
                    className="col-lg-12 col-md-4 padding-0"
                    maxRows={10}
                  />
                </div>
              </div>
              <div className="flex" style={{ flexDirection: 'column' }}>
                {renderInputFieldWithTextBox(
                  'partnerUSG',
                  patientData.investigationOfFemalePartner.partnerUSG,
                  handleInputChange,
                  '',
                  'USG',
                )}

                <label htmlFor="partnerUSGDate">USG Date</label>
                <DateComponent
                  selectedDate={selectedDates['partnerUSGDate']}
                  handleDateChange={(date, dateString) =>
                    handleDateChange(date, dateString, 'partnerUSGDate')
                  }
                />

                {renderInputFieldWithTextBox(
                  'partnerUterus',
                  patientData.investigationOfFemalePartner.partnerUterus,
                  handleInputChange,
                  '',
                  'Uterus',
                )}

                {renderInputFieldWithTextBox(
                  'partnerET',
                  patientData.investigationOfFemalePartner.partnerET,
                  handleInputChange,
                  '',
                  'ET (Endometrial Thickness)',
                )}

                {renderInputFieldWithTextBox(
                  'partnerRightOvary',
                  patientData.investigationOfFemalePartner.partnerRightOvary,
                  handleInputChange,
                  '',
                  'Right Ovary',
                )}

                {renderInputFieldWithTextBox(
                  'partnerLeftOvary',
                  patientData.investigationOfFemalePartner.partnerLeftOvary,
                  handleInputChange,
                  '',
                  'Left Ovary',
                )}
              </div>
            </div> */}
            <div style={{ display: 'flex', gap: 20 }}>
              <div className="card_name_container female-examination-container">
                <TableContainer
                  component={Paper}
                  sx={{ boxShadow: '0 1px 2px 1px rgba(0, 0, 0, 0.1)' }}
                >
                  <Table style={{ tableLayout: 'fixed' }}>
                    <TableHead>
                      {Array.from({ length: 2 }).map((_, index) => (
                        <TableCell key={index}></TableCell>
                      ))}
                    </TableHead>
                    <TableBody>{tableOneRowTitles.map(renderRow)}</TableBody>
                  </Table>
                </TableContainer>
              </div>
              <div className="card_name_container female-examination-container">
                <TableContainer
                  component={Paper}
                  sx={{ boxShadow: '0 1px 2px 1px rgba(0, 0, 0, 0.1)' }}
                >
                  <Table style={{ tableLayout: 'fixed' }}>
                    <TableHead>
                      {Array.from({ length: numberOfColumns }).map(
                        (_, index) => (
                          <TableCell key={index}></TableCell>
                        ),
                      )}
                    </TableHead>
                    <TableBody>{tableTwoRowTitles.map(renderRow)}</TableBody>
                  </Table>
                </TableContainer>
              </div>
            </div>

            <div style={{ display: 'flex', gap: 20, marginTop: 20 }}>
              <div className="card_name_container female-examination-container">
                <TableContainer
                  component={Paper}
                  sx={{ boxShadow: '0 1px 2px 1px rgba(0, 0, 0, 0.1)' }}
                >
                  <Table style={{ tableLayout: 'fixed' }}>
                    {/* <TableHead></TableHead> */}
                    {/* <TableBody style={{ display: 'flex' }}> */}
                    {tableThreeRowTitles.map(renderRow)}
                    {/* </TableBody> */}
                  </Table>
                </TableContainer>
              </div>
              {/* <div className="card_name_container female-examination-container">
                <TableContainer
                  component={Paper}
                  sx={{ boxShadow: '0 1px 2px 1px rgba(0, 0, 0, 0.1)' }}
                >
                  <Table style={{ tableLayout: 'fixed' }}>
                    <TableHead>
                      <TableCell />
                      {Array.from({ length: numberOfColumns }).map(
                        (_, index) => (
                          <TableCell key={index}></TableCell>
                        ),
                      )}
                    </TableHead>
                  </Table>
                </TableContainer>
              </div> */}
            </div>

            <div style={{ marginTop: 20 }}>
              <div className="card_name_container female-examination-container">
                <TableContainer
                  component={Paper}
                  sx={{ boxShadow: '0 1px 2px 1px rgba(0, 0, 0, 0.1)' }}
                >
                  <Table style={{ tableLayout: 'fixed' }}>
                    <TableHead>
                      <TableRow>
                        <TableCell>USG</TableCell>
                        <TableCell>USG Date</TableCell>
                        <TableCell>Uterus</TableCell>

                        <TableCell>ET (Endometrial Thickness)</TableCell>
                        <TableCell>Right Ovary</TableCell>
                        <TableCell>Left Ovary</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {/* <div style={{ display: 'flex', width: '100%' }}> */}
                      {renderCell(tableFiveRowTitles)}
                      {/* </div> */}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </div>

            <p className="lead">Comments</p>
            <CustomTextArea
              value={patientData.investigationOfFemalePartner.comments}
              onChange={handleInputChange}
              name="comments"
            />

            {/* <div className="card_name_container">
              {renderInputField(
                'comments',
                'comments',
                patientData.investigationOfFemalePartner.comments,
                handleInputChange,
              )}
            </div> */}
            {/* <div style={{ paddingTop: '50px' }}>
              <div className="row clearfix">
                <FileUploadCard
                  setFiles={setFiles}
                  setUploadedFiles={setUploadedFiles}
                  files={uploadedFiles}
                  handleUpload={handleUpload}
                  id={patientId}
                />
                {uploadedFiles.map((data, i) => {
                  console.log('uploadedFiles', uploadedFiles);
                  return (
                    <FileDocumentCard
                      key={i}
                      DocumentName={data.displayFileName}
                      DocumentSize={(data.size / 1024).toFixed(2) + ' KB'}
                      DocumentDate={new Date(
                        data.updatedAt,
                      ).toLocaleDateString()}
                      ImageUrl={
                        data?.fileType?.includes('image')
                          ? data.presignedUrl
                          : undefined
                      }
                      handleDeleteFile={() => handleDeleteFile(data)}
                      file={data}
                      fileUniquePrefix={`patient-${patientId}`}
                    />
                  );
                })}
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvestigationOfFemalePartner;
